import React from "react";

interface Props {
  className?: string;
}

export const PauseIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="34"
      height="54"
      viewBox="0 0 34 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <rect
        x="23.4643"
        y="53.7144"
        width="53.7143"
        height="10.0714"
        transform="rotate(-90 23.4643 53.7144)"
        fill="url(#paint0_radial)"
      />
      <rect
        x="10.0714"
        width="53.7143"
        height="10.0714"
        transform="rotate(90 10.0714 0)"
        fill="url(#paint1_radial)"
      />
      <defs>
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(81.4643 41.2501) rotate(147.836) scale(57.2931 305.563)"
        >
          <stop stopColor="#F2F2F2" stopOpacity="0" />
          <stop offset="1" stopColor="#4FFF80" />
        </radialGradient>
        <radialGradient
          id="paint1_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(83.5714 -19.9286) rotate(149.324) scale(74.413 396.869)"
        >
          <stop stopColor="#F2F2F2" stopOpacity="0" />
          <stop offset="1" stopColor="#4FFF80" />
        </radialGradient>
      </defs>
    </svg>
  );
};
